// extracted by mini-css-extract-plugin
var _1 = "qp2vC5alqYLjMlTERDAG";
export { _1 as "paragraphStyle" }
